/**
 * Returns true when the team member's rich-text summary has visible text after
 * stripping tags and normalising whitespace. Placeholder HTML such as `<p><br></p>`
 * is treated as empty.
 */
export function hasRenderableTeamMemberSummary(
    html: string | null | undefined,
): boolean {
    if (!html?.trim()) {
        return false;
    }

    const withoutTags = html.replace(/<[^>]+>/g, '');
    const text = withoutTags
        .replace(/&nbsp;/gi, ' ')
        .replace(/\u00A0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    return text.length > 0;
}
